import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { createApolloFetch } from 'apollo-fetch';
import {Skeleton} from '@material-ui/lab'


import YourBiographiesPage from './your-biographies-page';
import {url} from '../../../url';
import {GET_BIO} from './apis'


// styles , icons and images
import img from '../../../images/person-placeholder.jpg';
import { Container, Row, Col, Card, Tab, Nav } from 'react-bootstrap';
import Loader from 'react-loader-spinner';
import { Button } from '@material-ui/core';

// this component represents  user visumes/biographies page 

class Biographies extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: ""
        }
    }
    componentDidUpdate(prevProps) {
        if (prevProps !== this.props) {
            if (this.props.get_biographies) {
                this.setState({ ...this.state, biographies: this.props.get_biographies.biosYours.data });
            }
        }

    }
    componentDidMount() {
        // open socket
        this.connect();
        // get biographies
        this.getBiographies();
    }
    getBiographies = () => {
        let that = this;
        const token = JSON.parse(localStorage.getItem('jwt')).BearerTokenResponse.access_token;
        const uri = url;
        const apolloFetch = createApolloFetch({ uri });
        apolloFetch.use(({ request, options }, next) => {
            if (!options.headers) {
                options.headers = {};  // Create the headers object if needed.
            }
            options.headers['authorization'] = `Bearer ${token}`;
            next();
        });

        // get user completed visume 
        apolloFetch({
            query:GET_BIO
        }).then(res => {
            console.log(res);
            if (res.data.me.biosYours) {
                let draft = res.data.me.biosYours.data.filter(bio => bio.is_Draft === true);
                let life = res.data.me.biosYours.data.filter(bio => bio.is_Draft === false);
                that.setState({ ...that.state, biographies: life , draftBiographies: draft });
            }
        });
        // get user draft visume 
        // apolloFetch({
        //     query:GET_BIO,
        //     variables : {isDraft : true}
        //     ,
        // }).then(res => {
        //     console.log(res);
        //     if (res.data.me.biosYours) {
        //         that.setState({ ...that.state, draftBiographies: res.data.me.biosYours.data  });
        //     }
        // })
        apolloFetch({
            query:
                `query{
                  me{
                    id
                    name
                    email
                    phone
                    __typename
                    profile_image{url}
                  }
                }
                `,
        }).then(res => {
            if (res.data.me) {
                that.setState({ ...that.state, user: res.data.me });
            }
        });
    }
    // open socket and get updated data 
    timeout = 250;
    connect = () => {
        var ws = new WebSocket("wss://spreago.black-squares.com:6001/app/websocket?protocol=7&client=js&version=4.3.1&flash=false");
        let that = this; // cache the this
        var connectInterval;

        // websocket onopen event listener
        ws.onopen = () => {
            console.log("connected websocket main component");
            ws.send('{"event":"pusher:subscribe","data":{"channel":"bio"}}');
            // this.setState({ ws: ws });
            // console.log(ws);
            that.timeout = 250; // reset timer to 250 on open of websocket connection 
            clearTimeout(connectInterval); // clear Interval on on open of websocket connection
        };

        // websocket onclose event listener
        ws.onclose = e => {
            console.log(
                `Socket is closed. Reconnect will be attempted in ${Math.min(
                    10000 / 1000,
                    (that.timeout + that.timeout) / 1000
                )} second.`,
                e.reason
            );

            that.timeout = that.timeout + that.timeout; //increment retry interval
            connectInterval = setTimeout(this.check, Math.min(10000, that.timeout)); //call check function after timeout
        };
        // websocket message 
        ws.onmessage = evt => {
            let newData = JSON.parse(evt.data)
            if (newData.event === "bioDelete" || newData.event === "bioEdit") {
                that.getBiographies();
                // let newBiography = JSON.parse(newData.data);
                // console.log(newBiography.bio)
                // let state = that.state.biographies;
                // let draftState = this.state.draftBiographies;
                // let filteredArray = state.filter(item => parseInt(item.id) !== parseInt(newBiography.bio_id))
                // let filteredDraftArray = draftState.filter(item => parseInt(item.id) !== parseInt(newBiography.bio_id))
                // that.setState({ ...that.state, biographies: filteredArray , draftBiographies : filteredDraftArray});
            }
        }
        // websocket onerror event listener
        ws.onerror = err => {
            console.error(
                "Socket encountered error: ",
                err.message,
                "Closing socket"
            );

            ws.close();
        };
    };
    /**
     * utilited by the @function connect to check if the connection is close, if so attempts to reconnect
     */
    check = () => {
        const { ws } = this.state;
        if (!ws || ws.readyState === WebSocket.CLOSED) this.connect(); //check if websocket instance is closed, if so call `connect` function.
    };
    render() {
        const biographies = this.state.biographies;
        if (!biographies) {
            return (
                <Container >
                    <Row className="pt-5">
                        <Col xs={3}>
                            <Skeleton variant="rect" height={250} />
                        </Col>
                        <Col xs={9}>
                            <Skeleton variant="text" className="mb-3" width={150} />
                            <Skeleton variant="rect" height={500} />
                        </Col>
                    </Row>
                </Container>
            )
        }
        else {
            // filter visumes
            let filteredArray = this.state.biographies.filter(bio => {
                return bio.questions.find(question => question.video !== null)
            })
            return (
                <div className="biographies">
                    <Container className="pt-5 container-fluid-responsive">
                        <Row className="m-0">
                            <Col sm={3} className="p-0 pt-2">
                                <Container className="container-responsive">
                                    <Card className="bg-white shadow pt-3 pb-5 border-0">
                                        <div className="text-center pb-3">
                                            <img src={this.state.user?.profile_image?this.state.user.profile_image.url : img} alt="interview img" width="120px" height="120px" className="rounded-circle" />
                                        </div>
                                        <div className="text-center">
                                            <div className=""><h6>{this.state.user?.name}</h6></div>
                                            {/* <div><p className="text-dark">0 Follower <span> . 0 Biography </span></p></div> */}
                                            <Button
                                                onClick={e => localStorage.setItem('updatedBio', '')}
                                                variant="contained"
                                                className="btn-orange text-white pb-1 pt-1 small-text"
                                                color="primary"
                                                size="large">
                                                <Link className="text-white" to='/createVisume'>Create Visume</Link>
                                            </Button>
                                        </div>
                                    </Card>
                                </Container>
                            </Col>
                            <Col sm={9} className="p-0 pt-2">
                                <Tab.Container defaultActiveKey="first">
                                    <Row className="m-0 pt-xs-4">
                                        <Col sm={12} className="mb-2">
                                            <Nav variant="pills" id="left-tabs-example">
                                                <Nav.Item>
                                                    <Nav.Link eventKey="first" className="mr-3 bg-transparent" style={{ outline: 'none' }}>
                                                        <h6>Live Visumes</h6>
                                                    </Nav.Link>
                                                </Nav.Item>
                                                <Nav.Item>
                                                    <Nav.Link eventKey="second" className="mr-3 bg-transparent" style={{ outline: 'none' }}>
                                                        <h6>Draft Visumes</h6>
                                                    </Nav.Link>
                                                </Nav.Item>
                                            </Nav>
                                        </Col>
                                        <Col sm={12} id="tab-content-container">
                                            <Tab.Content>
                                                <Tab.Pane eventKey="first">
                                                    <YourBiographiesPage data={filteredArray && filteredArray} type="Your Live Visumes" />
                                                </Tab.Pane>
                                                <Tab.Pane eventKey="second" >
                                                    <YourBiographiesPage data={this.state.draftBiographies && this.state.draftBiographies} type="Your Draft Visumes" />
                                                </Tab.Pane>
                                            </Tab.Content>
                                        </Col>
                                    </Row>
                                </Tab.Container>
                            </Col>
                        </Row>
                    </Container>
                </div>
            );
        }
    }
}

export default withRouter(Biographies);